import React from "react";
import { useSelector } from "react-redux";

import { getBiller } from "selectors";
import { IImageResources, IContactInfo } from "types/biller";
import { PayableBreadcrumb } from "components/ezpay/common/payable-breadcrumb";

interface PayableCardHeaderProps {
  showBreadcrumb?: boolean;
}

export function PayableCardHeader({ showBreadcrumb = true }: PayableCardHeaderProps) {
  const biller = useSelector(getBiller);

  const imageResources = biller?.properties?.find((element) => {
    return element.name === "ImageResources";
  }) as IImageResources;

  const contactUs = biller?.properties?.find((element) => {
    return element.name === "InstanceConfiguration";
  }) as IContactInfo;

  return (
    <div className={showBreadcrumb ? "payable-card-header" : "payable-card-header-spacer"}>
      {showBreadcrumb && <PayableBreadcrumb />}
    </div>
  );
}
